/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Component, Injector, Input } from '@angular/core';
import { type Command, type PromptConfigFull, DeleteAbstract } from '@dm/core';
import { type CIFSShare, type IpWhiteList } from 'app/common/types/mo';

import { IpWhiteListService } from '../ip-white-list.service';
import { IpWhiteListStrService } from '../ip-white-list-str.service';

@Component({
    selector: 'app-remove-ip-white-list',
    templateUrl: './remove-ip-white-list.component.html',
    styleUrls: ['./remove-ip-white-list.component.scss'],
})
export class RemoveIpWhiteListComponent extends DeleteAbstract<IpWhiteList> {
    @Input() cifsData: CIFSShare;
    @Input() dataList: IpWhiteList[];
    i18n = this.str.i18n;

    constructor(
        injector: Injector,
        private str: IpWhiteListStrService,
        private service: IpWhiteListService,
    ) {
        super(injector);
    }

    initTable(): void {
        this.tableColumnDefs = [
            {
                field: 'rule',
                header: this.i18n.rules,
            },
            {
                field: 'ID',
                header: this.i18n.id,
            },
        ];
    }

    prompt(): PromptConfigFull[] {
        const prompts: PromptConfigFull[] = [
            {
                id: 'prompt-remove-ip-white-list-removeIpWhiteListTip',
                canHidden: true,
                opType: 'warning',
                title: this.i18n.removeIpWhiteListTitle,
                content: this.i18n.removeIpWhiteListTip,
                templateRef: this.tableTemplate,
                width: 700,
            },
        ];

        return prompts;
    }

    buildCmds(): Command[] {
        const cmds = [];
        this.dataList.forEach((item) =>
            cmds.push({
                name: this.i18n.removeIpWhiteListAction(item.rule),
                action: this.service.removeIpWhiteList(item.ID, this.cifsData.vstoreId),
            }),
        );

        return cmds;
    }
}
